'use strict';

class SolutionScroller {

    constructor() {

        // get all scrollers
        const solutionScrollers = document.querySelectorAll('.ce-solution-scroller');

        // if there is a scroller
        if (solutionScrollers) {

            // for each scroller, init functionality
            for (let scroller of solutionScrollers) {
                this.scrollerInit(scroller);

            }
        }
    }
    
    scrollerInit(scroller) {
        const scrollerActiveClass = 'ce-solution-scroller--active';
        const stickyImageHiddenClass = 'ce-solution-scroller__image--hidden';
        const stickyImageVisibleClass = 'ce-solution-scroller__image--visible';
        const indicator = scroller.querySelector('.ce-solution-scroller__indicator');
        const stickyImages = scroller.querySelectorAll('.ce-solution-scroller__image');
        const entries = scroller.querySelectorAll('.ce-solution-scroller-entry');
        const entriesYpos = [...entries].map(entry => entry.offsetTop);

        // hide all images by default
        for (const image of stickyImages) {
            image.classList.add(stickyImageHiddenClass);
            image.classList.remove(stickyImageVisibleClass);
        }

        // add an active class to the scroller for styling purposes
        scroller.classList.add(scrollerActiveClass);

        // observer to check if we need to listen for a scroll event
        const scrollerBlockObserver = new IntersectionObserver((entries, scrollerBlockObserver) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    window.addEventListener('scroll', scrollHandler);
                } else {
                    window.removeEventListener('scroll', scrollHandler);
                }
            
            })
        }, { threshold: 0 });

        // observe the indicator
        scrollerBlockObserver.observe(indicator);

        // handle scroll event when indicator is in view
        function scrollHandler() {

            // for each entry Y postion
            entriesYpos.forEach((pos, i) => {

                // if the indicator pos > current pos but smaller then the next pos
                if (indicator.offsetTop >= pos && (entriesYpos[i + 1] === undefined || indicator.offsetTop < entriesYpos[i + 1])) {

                    // hide all images but the current one
                    stickyImages.forEach((image, index) => {
                        if (i === index) return;
                        image.classList.remove(stickyImageVisibleClass);
                        image.classList.add(stickyImageHiddenClass);
                    });

                    // show the current related image
                    stickyImages[i].classList.add(stickyImageVisibleClass);

                }

            });
        }
    }
}

module.exports = SolutionScroller;
